var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskLvp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.053 4c2.44 0 4.45 1.754 4.708 4.007A4.5 4.5 0 0 1 21.744 11H2.105c.488-2.282 2.612-4 5.158-4 .438 0 .864.05 1.27.147C9.139 5.323 10.934 4 13.054 4m-2.078 14.592H2v1.632h9zm3.025 0h7.976L22 20.224h-8zm-8.447-2.95L2 15.64v1.631h3.552zM8 15.64l14 .001v1.63H8zm-5.976-1.32H13.16V12.69l-11.136-.001zm19.976 0h-7v-1.632h7z",
  clipRule: "evenodd"
})));
export default SvgTaskLvp;